import { render, staticRenderFns } from "./RappiItems.vue?vue&type=template&id=c50a6b5c&scoped=true"
import script from "./RappiItems.vue?vue&type=script&lang=js"
export * from "./RappiItems.vue?vue&type=script&lang=js"
import style0 from "./RappiItems.vue?vue&type=style&index=0&id=c50a6b5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c50a6b5c",
  null
  
)

export default component.exports